import { useParams, Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import Breadcrumb from '@/components/feature/Breadcrumb';

const categoryLabelMap: Record<string, string> = {
  entertainment: '娱乐圈',
  influencer: '网红主播',
  society: '社会事件',
  tech: '科技圈',
  sports: '体育圈',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = categories.find(c => c.slug === slug);
  const categoryName = currentCategory?.name || (slug ? categoryLabelMap[slug] || slug : '全部');
  const categoryDesc = currentCategory?.description || '所有分类的最新爆料内容';

  const filteredArticles = slug && slug !== 'all'
    ? articles.filter(a => a.categorySlug === slug)
    : articles;

  return (
    <>
      <Navbar />
      <Breadcrumb />

      <main>
        {/* Category Header */}
        <section className="py-8 md:py-10 bg-background-50">
          <div className="container-custom">
            <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-2">
              {categoryName}
            </h1>
            <p className="text-sm text-foreground-500">{categoryDesc}</p>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="bg-background-50 border-b border-background-200/70">
          <div className="container-custom">
            <div className="flex items-center gap-2 overflow-x-auto pb-1 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                  className={`inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                    slug === cat.slug || (!slug && cat.slug === 'all')
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
                  }`}
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  {cat.name}
                  {cat.slug !== 'all' && (
                    <span className="text-xs opacity-70 ml-0.5">({cat.count})</span>
                  )}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="container-custom">
            {filteredArticles.length > 0 ? (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                  {filteredArticles.map((article) => (
                    <ArticleCard key={article.id} article={article} variant="default" />
                  ))}
                </div>
                <p className="text-center text-sm text-foreground-500 mt-8">
                  共 {filteredArticles.length} 篇文章
                </p>
              </>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-inbox-line text-3xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-500">该分类暂无文章</p>
                <Link to="/" className="inline-block mt-4 text-sm text-primary-500 hover:text-primary-600 cursor-pointer">
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}